import { Cloudinary } from 'cloudinary-core';

import { getEnvironment } from '../utils.mjs';

export const defaultLibraryConfig = {
  secure: true,
};

const { CLOUDINARY_CLOUD_NAME } = getEnvironment();

const cloud = Cloudinary.new({
  ...defaultLibraryConfig,
  cloud_name: CLOUDINARY_CLOUD_NAME,
});

cloud.init();

export { cloud };
